/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Error, ErrorIcon, ErrorTitle, ErrorDescription } from '@quadminds/mindkit';
import IconDark from '@quadminds/mindy-app/assets/img/errors/SearchDark.svg';
import IconLight from '@quadminds/mindy-app/assets/img/errors/SearchLight.svg';
import useGetUserInfo from '@quadminds/mindy-app/hooks/useGetUserInfo';
// import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function UserNotFound() {
    console.warn('UserNotFound component rendered, user is not found');
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { data: userInfo } = useGetUserInfo();
    const navigate = useNavigate();

    useEffect(() => {
        if (userInfo !== undefined) {
            navigate('/chat');
        }

        if (
            localStorage.getItem('token') !== null &&
            userInfo === undefined &&
            queryClient.getQueryState(['userInfo'])?.status !== 'pending'
        ) {
            console.warn('UserNotFound: User info is undefined, refetching user info');
            queryClient.refetchQueries({ queryKey: ['userInfo'] });
        }
    }, [navigate, queryClient, userInfo]);

    return (
        <Error>
            <ErrorIcon>
                <img src={IconLight} alt="Error" className="dark:hidden h-24 w-auto" />
                <img src={IconDark} alt="Error" className="hidden dark:block h-24 w-auto" />
            </ErrorIcon>
            <ErrorTitle>{t('errors.userNotFound')}</ErrorTitle>
            <ErrorDescription>
                <p>{t('errors.userNotFoundDescription')}</p>
                <p>{t('errors.userNotFoundDescription2')}</p>
            </ErrorDescription>
        </Error>
    );
}

export default UserNotFound;
